import React, { useRef, useState } from "react";
import { useMotionValueEvent, useScroll } from "framer-motion";

import { css } from "@emotion/css";

import { desktop, laptop, mobile, tablet } from "../../../styles/breakpoints";
import SuggestList from "../../../img/png/tech/suggestions-explore-list.png";
import { useI18n } from "../../../i18n";

const Suggestions = () => {
  const { t } = useI18n();
  const ref = useRef(null);
  const { scrollY } = useScroll();
  const [slide, setSlide] = useState(1);

  const overlayHeight = 7000;

  useMotionValueEvent(
    scrollY,
    "change",
    (latest) => {
      if (!ref.current?.offsetParent) return;
      const value =
        (100 * (latest - ref.current.offsetParent.offsetTop)) / overlayHeight;

      if (value > 76) {
        setSlide(20);
      } else if (value > 72) {
        setSlide(19);
      } else if (value > 68) {
        setSlide(18);
      } else if (value > 64) {
        setSlide(17);
      } else if (value > 60) {
        setSlide(16);
      } else if (value > 56) {
        setSlide(15);
      } else if (value > 52) {
        setSlide(14);
      } else if (value > 48) {
        setSlide(13);
      } else if (value > 44) {
        setSlide(12);
      } else if (value > 40) {
        setSlide(11);
      } else if (value > 36) {
        setSlide(10);
      } else if (value > 32) {
        setSlide(9);
      } else if (value > 28) {
        setSlide(8);
      } else if (value > 24) {
        setSlide(7);
      } else if (value > 20) {
        setSlide(6);
      } else if (value > 16) {
        setSlide(5);
      } else if (value > 12) {
        setSlide(4);
      } else if (value > 8) {
        setSlide(3);
      } else if (value > 4) {
        setSlide(2);
      } else {
        setSlide(1);
      }
    },
    []
  );

  return (
    <div style={{ position: "relative", backgroundColor: "#000" }}>
      <div className={`${style.container} slide${slide}`}>
        <div className="heading">
          <div className="wrapper element1">
            <h3>{t("tech_suggestions_plus")}</h3>
            <h2>{t("tech_suggestions_title")}</h2>
            <h3>{t("tech_suggestions_tailored")}</h3>
          </div>
          <div className="wrapper element2">
            <h3>
            {t("tech_suggestions_build")}
            </h3>
            <h2>{t("tech_suggestions_look")}</h2>
          </div>
        </div>
        <div className="animation">
          <div className="suggestions">
            <span className="bohemian" style={{ backgroundColor: "#181DD9" }}>
              {t("tech_style_bohemian")}
            </span>
            <span
              className="romantic"
              style={{ backgroundColor: "#FEFA8E", color: "#000" }}
            >
              {t("tech_style_romantic")}
            </span>
            <span
              className="elegant"
              style={{ backgroundColor: "#FFF", color: "#000" }}
            >
              {t("tech_style_elegant")}
            </span>
            <span
              className="old"
              style={{ backgroundColor: "#B577FF", color: "#000" }}
            >
              {t("tech_style_old_money")}
            </span>
            <span className="coctail" style={{ backgroundColor: "#F14B5B" }}>
              {t("tech_style_cocktail")}
            </span>

            <span
              className="smart"
              style={{ backgroundColor: "#CBFFD6", color: "#000" }}
            >
              {t("tech_style_smart_casual")}
            </span>
            <span
              className="athletic"
              style={{ backgroundColor: "#FF6BFF", color: "#000" }}
            >
              {t("tech_style_athletic")}
            </span>
            <span className="dinner" style={{ backgroundColor: "#181DD9" }}>
              {t("tech_style_dinner")}
            </span>
            <span
              className="winter"
              style={{ backgroundColor: "#FEFA8E", color: "#000" }}
            >
              {t("tech_style_winter_elegant")}
            </span>
            <span
              className="autumn"
              style={{ backgroundColor: "#FFF", color: "#000" }}
            >
              {t("tech_style_casual_autumn")}
            </span>
            <span
              className="streetwear"
              style={{ backgroundColor: "#B577FF", color: "#000" }}
            >
              {t("tech_style_streetwear")}
            </span>
            <span className="edgy" style={{ backgroundColor: "#F14B5B" }}>
              {t("tech_style_edgy")}
            </span>
            <span
              className="casual"
              style={{ backgroundColor: "#CBFFD6", color: "#000" }}
            >
              {t("tech_style_casual_chic")}
            </span>
            <span
              className="evening"
              style={{ backgroundColor: "#FF6BFF", color: "#000" }}
            >
              {t("tech_style_evening_glam")}
            </span>
          </div>
        </div>

        <div className="final">{t("tech_suggestions_ai")}</div>
      </div>
      <div
        tabIndex={1}
        ref={ref}
        className={style.overlay(overlayHeight)}
      ></div>
    </div>
  );
};

const style = {
  overlay: (overlayHeight) =>
    css({
      width: "100%",
      height: overlayHeight,
    }),
  container: css({
    height: "100vh",
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    alignContent: "center",
    justifyContent: "center",
    alignItems: "stretch",
    maxWidth: 1830,
    margin: "auto",
    padding: 40,
    position: "sticky",
    overflow: "hidden",
    zIndex: 1,
    top: 0,
    background: "#000",
    gap: 100,

    ".final": {
      transition: "all 1s",
      position: 'absolute',
      left: 0,
      right: 0,
      top: '40%',
      margin: 'auto',
      color: '#FFF',
      textAlign: 'center',
      fontFamily: 'Syne',
      fontSize: 61.25,
      fontStyle: 'normal',
      fontWeight: 700,
      lineHeight: '75px',
      zIndex: -1,
      opacity: 0,
      background: 'linear-gradient(90deg, #000, #fff, #000)',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '65%',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'rgba(255, 255, 255, 0)',
      backgroundPosition: '-294.839% 0px',
    },
    ".animation": {
      transition: "all 1s",
      position: "relative",
      width: "50%",
      height: "90vh",
      display: "flex",
      flexDirection: "column",
      flexWrap: "nowrap",
      alignContent: "center",
      justifyContent: "center",
      alignItems: "center",

      ".suggestions": {
        position: "absolute",
        width: "100%",
        height: "100%",
        borderRadius: 0,
        background: "#000",
        transition: "all 1s",

        "&:before": {
          transition: "all 1s",
          content: '""',
          display: "block",
          position: "absolute",
          left: 0,
          top: 0,
          width: "100%",
          height: "100%",
          opacity: 0,
          backgroundImage: `url(${SuggestList})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "50%",
          backgroundSize: "cover",
        },

        span: {
          height: 97,
          alignSelf: "stretch",
          borderRadius: 29.04,
          background: "#181DD9",
          color: "#FFF",
          fontFamily: "Inter",
          fontSize: 35.841,
          fontStyle: "normal",
          fontWeight: 500,
          lineHeight: "100%",
          letterSpacing: 0.506,
          width: "100%",
          maxWidth: 513,
          position: "absolute",
          textAlign: "center",
          display: "flex",
          flexDirection: "row",
          flexWrap: "nowrap",
          alignContent: "center",
          justifyContent: "center",
          alignItems: "center",
          transition: "all 1s",
          left: 0,
          right: 0,
          marginLeft: "auto",
          marginRight: "auto",

          "&.smart, &.athletic, &.dinner, &.winter, &.autumn, &.streetwear, &.edgy, &.casual, &.evening":
            {
              display: "none",
            },
        },
      },
    },

    ".heading": {
      transition: "all 1s",
      display: "flex",
      flexDirection: "column",
      flexWrap: "nowrap",
      alignContent: "center",
      justifyContent: "center",
      alignItems: "center",
      gap: 23,
      maxWidth: 522,

      ".wrapper": {
        transition: "all 1s",
        display: "flex",
        flexDirection: "column",
        flexWrap: "nowrap",
        alignContent: "center",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        gap: 23,

        h3: {
          color: "#FFF",
          textAlign: "center",
          fontFamily: "Syne",
          fontSize: 60.543,
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "59.994px",
        },
        h2: {
          display: "flex",
          transform: "rotate(-4deg)",
          padding: "20.469px 40.938px 30.722px 40.938px",
          justifyContent: "center",
          alignItems: "center",
          gap: 6.823,
          borderRadius: 106.956,
          background: "#6643FF",
          boxShadow: "5.906px 7.874px 0px 0px #462EE9",
          color: "#FFF",
          textAlign: "center",
          fontFamily: "Syne",
          fontSize: 57.963,
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "53.749px",
          maxWidth: 432,
        },

        "&.element1": {
          opacity: 1,
          marginBottom: 350,
        },
        "&.element2": {
          opacity: 0,
          bottom: "-50%",
          position: "absolute",

          h3: {
            textAlign: "left",
            maxWidth: 509,
            fontSize: 49,
            lineHeight: "65px",
          },
          h2: {
            fontSize: 58,
            maxWidth: 432,
            width: "100%",
          },
        },
      },
    },

    "&.slide1": {
      ".animation": {
        ".suggestions": {
          span: {
            top: "10%",
            opacity: 0.39,

            "&.bohemian": {
              top: "11%",
              transform: "scale(0.55) rotate(34.422deg)",
            },
            "&.romantic": {
              top: "12%",
              transform: "scale(0.55) rotate(33.42deg)",
            },
            "&.elegant": {
              top: "13%",
              transform: "scale(0.55) rotate(32.86deg)",
            },
            "&.old": {
              top: "14%",
              transform: "scale(0.55) rotate(30.877deg)",
            },
            "&.coctail": {
              top: "15%",
              transform: "scale(0.55) rotate(29.293deg)",
            },
          },
        },
      },
    },

    "&.slide2": {
      ".animation": {
        ".suggestions": {
          span: {
            opacity: 0.66,

            "&.bohemian": {
              top: "21%",
              transform: "scale(0.65) rotate(30.153deg)",
            },
            "&.romantic": {
              top: "22%",
              transform: "scale(0.65) rotate(29.151deg)",
            },
            "&.elegant": {
              top: "23%",
              transform: "scale(0.65) rotate(29.766deg)",
            },
            "&.old": {
              top: "24%",
              transform: "scale(0.65) rotate(26.608deg)",
            },
            "&.coctail": {
              top: "25%",
              transform: "scale(0.65) rotate(25.024deg)",
            },
          },
        },
      },
    },

    "&.slide3": {
      ".animation": {
        ".suggestions": {
          span: {
            opacity: 0.9,

            "&.bohemian": {
              top: "31%",
              transform: "scale(0.75) rotate(33.559deg)",
            },
            "&.romantic": {
              top: "32%",
              transform: "scale(0.75) rotate(32.557deg)",
            },
            "&.elegant": {
              top: "33%",
              transform: "scale(0.75) rotate(31.996deg)",
            },
            "&.old": {
              top: "34%",
              transform: "scale(0.75) rotate(30.014deg)",
            },
            "&.coctail": {
              top: "35%",
              transform: "scale(0.75) rotate(28.43deg)",
            },
          },
        },
      },
    },

    "&.slide4": {
      ".animation": {
        ".suggestions": {
          span: {
            opacity: 1,
            top: "40%",
            transform: "scale(1) rotate(0deg)",
          },
        },
      },
    },

    "&.slide5": {
      ".animation": {
        ".suggestions": {
          span: {
            "&.bohemian": {
              top: "32%",
            },
            "&.romantic": {
              top: "36%",
            },
            "&.elegant": {
              top: "40%",
            },
            "&.old": {
              top: "44%",
            },
            "&.coctail": {
              top: "48%",
            },
          },
        },
      },
    },

    "&.slide6": {
      ".animation": {
        ".suggestions": {
          span: {
            "&.bohemian": {
              top: "26%",
            },
            "&.romantic": {
              top: "32%",
            },
            "&.elegant": {
              top: "40%",
            },
            "&.old": {
              top: "48%",
            },
            "&.coctail": {
              top: "56%",
            },
          },
        },
      },
    },

    "&.slide7": {
      ".heading": {
        ".wrapper": {
          "&.element1": {
            opacity: 0.5,
          },
        },
      },
      ".animation": {
        ".suggestions": {
          borderRadius: 50,
          background: "#3b3a4b",
          width: 550,
          height: 580,
          overflow: "hidden",
          span: {
            "&.bohemian": {
              top: "-5%",
            },
            "&.romantic": {
              top: "17%",
            },
            "&.elegant": {
              top: "40%",
            },
            "&.old": {
              top: "62%",
            },
            "&.coctail": {
              top: "85%",
            },
            "&.smart, &.athletic, &.dinner": {
              top: "130%",
            },
          },
        },
      },
    },

    "&.slide8": {
      ".heading": {
        ".wrapper": {
          "&.element1": {
            opacity: 0,
          },
        },
      },
      ".animation": {
        ".suggestions": {
          borderRadius: 50,
          background: "#3b3a4b",
          width: 550,
          height: 580,
          overflow: "hidden",
          span: {
            "&.bohemian": {
              top: "-5%",
            },
            "&.romantic": {
              top: "17%",
            },
            "&.elegant": {
              top: "40%",
            },
            "&.old": {
              top: "62%",
            },
            "&.coctail": {
              top: "85%",
            },
            "&.smart": {
              display: "flex",
              top: "110%",
            },
            "&.athletic": {
              display: "flex",
              top: "130%",
            },
            "&.dinner": {
              display: "flex",
              top: "150%",
            },
          },
        },
      },
    },

    "&.slide9": {
      ".heading": {
        ".wrapper": {
          "&.element1": {
            opacity: 0,
          },
          "&.element2": {
            opacity: 0.5,
            bottom: "-5%",
          },
        },
      },
      ".animation": {
        ".suggestions": {
          borderRadius: 50,
          background: "#3b3a4b",
          width: 550,
          height: 580,
          overflow: "hidden",
          span: {
            "&.bohemian, &.romantic": {
              top: "-30%",
            },
            "&.smart, &.athletic, &.dinner, &.winter": {
              display: "flex",
            },
            "&.elegant": {
              top: "-5%",
            },
            "&.old": {
              top: "17%",
            },
            "&.coctail": {
              top: "40%",
            },
            "&.smart": {
              top: "62%",
            },
            "&.athletic": {
              top: "85%",
            },
            "&.dinner": {
              top: "110%",
            },
            "&.winter": {
              top: "130%",
            },
            "&.autumn": {
              top: "150%",
            },
          },
        },
      },
    },

    "&.slide10": {
      ".heading": {
        ".wrapper": {
          "&.element1": {
            opacity: 0,
          },
          "&.element2": {
            opacity: 0.5,
            bottom: "5%",
          },
        },
      },
      ".animation": {
        ".suggestions": {
          borderRadius: 50,
          background: "#3b3a4b",
          width: 550,
          height: 580,
          overflow: "hidden",
          span: {
            "&.bohemian, &.elegant, &.romantic, &.old": {
              top: "-30%",
            },
            "&.smart, &.athletic, &.dinner, &.winter, &.autumn, &.streetwear, &.edgy":
              {
                display: "flex",
              },
            "&.coctail": {
              top: "-5%",
            },
            "&.smart": {
              top: "17%",
            },
            "&.athletic": {
              top: "40%",
            },
            "&.dinner": {
              top: "62%",
            },
            "&.winter": {
              top: "85%",
            },
            "&.autumn": {
              top: "110%",
            },
            "&.streetwear": {
              top: "130%",
            },
            "&.edgy": {
              top: "150%",
            },
            // "&.casual": {
            //   top: "85%",
            // },
            // "&.evening": {
            //   top: "85%",
            // },
          },
        },
      },
    },

    "&.slide11": {
      ".heading": {
        ".wrapper": {
          "&.element1": {
            opacity: 0,
          },
          "&.element2": {
            opacity: 0.7,
            bottom: "10%",
          },
        },
      },
      ".animation": {
        ".suggestions": {
          borderRadius: 50,
          background: "#3b3a4b",
          width: 550,
          height: 580,
          overflow: "hidden",
          span: {
            "&.bohemian, &.elegant, &.romantic, &.old, &.coctail, &.smart": {
              top: "-30%",
            },
            "&.smart, &.athletic, &.dinner, &.winter, &.autumn, &.streetwear, &.edgy, &.casual, &.evening":
              {
                display: "flex",
              },
            "&.athletic": {
              top: "-5%",
            },
            "&.dinner": {
              top: "17%",
            },
            "&.winter": {
              top: "40%",
            },
            "&.autumn": {
              top: "62%",
            },
            "&.streetwear": {
              top: "85%",
            },
            "&.edgy": {
              top: "110%",
            },
            "&.casual": {
              top: "130%",
            },
            "&.evening": {
              top: "150%",
            },
          },
        },
      },
    },

    "&.slide12": {
      ".heading": {
        ".wrapper": {
          "&.element1": {
            opacity: 0,
          },
          "&.element2": {
            opacity: 1,
            bottom: "20%",
          },
        },
      },
      ".animation": {
        ".suggestions": {
          borderRadius: 50,
          background: "#3b3a4b",
          width: 550,
          height: 580,
          overflow: "hidden",
          span: {
            "&.bohemian, &.elegant, &.romantic, &.old, &.coctail, &.smart, &.athletic, &.dinner, &.winter":
              {
                top: "-30%",
              },
            "&.smart, &.athletic, &.dinner, &.winter, &.autumn, &.streetwear, &.edgy, &.casual, &.evening":
              {
                display: "flex",
              },
            "&.autumn": {
              top: "-5%",
            },
            "&.streetwear": {
              top: "17%",
            },
            "&.edgy": {
              top: "40%",
            },
            "&.casual": {
              top: "62%",
            },
            "&.evening": {
              top: "85%",
            },
          },
        },
      },
    },

    "&.slide13": {
      ".heading": {
        ".wrapper": {
          "&.element1": {
            opacity: 0,
          },
          "&.element2": {
            opacity: 1,
            bottom: "30%",
          },
        },
      },
      ".animation": {
        ".suggestions": {
          borderRadius: 50,
          background: "#000",
          width: 550,
          height: 580,
          overflow: "hidden",
          "&:before": {
            opacity: 0.5,
          },

          span: {
            "&.bohemian, &.elegant, &.romantic, &.old, &.coctail, &.smart, &.athletic, &.dinner, &.winter":
              {
                top: "-30%",
              },
            "&.smart, &.athletic, &.dinner, &.winter, &.autumn, &.streetwear, &.edgy, &.casual, &.evening":
              {
                display: "flex",
              },
            "&.autumn": {
              top: "2%",
              transform: "scale(0.85)",
            },
            "&.streetwear": {
              top: "20%",
              transform: "scale(0.85)",
            },
            "&.edgy": {
              top: "40%",
              transform: "scale(0.85)",
            },
            "&.casual": {
              top: "60%",
              transform: "scale(0.85)",
            },
            "&.evening": {
              top: "80%",
              transform: "scale(0.85)",
            },
          },
        },
      },
    },

    "&.slide14": {
      ".heading": {
        ".wrapper": {
          "&.element1": {
            opacity: 0,
          },
          "&.element2": {
            opacity: 1,
            bottom: "33%",
          },
        },
      },
      ".animation": {
        ".suggestions": {
          borderRadius: 50,
          background: "#000",
          width: 550,
          height: 580,
          overflow: "hidden",
          "&:before": {
            opacity: 0.5,
          },

          span: {
            "&.bohemian, &.elegant, &.romantic, &.old, &.coctail, &.smart, &.athletic, &.dinner, &.winter":
              {
                top: "-30%",
              },
            "&.smart, &.athletic, &.dinner, &.winter, &.autumn, &.streetwear, &.edgy, &.casual, &.evening":
              {
                display: "flex",
              },
            "&.autumn": {
              top: "2%",
              transform: "scale(0.40)",
              opacity: 0,
            },
            "&.streetwear": {
              top: "25%",
              transform: "scale(0.40)",
            },
            "&.edgy": {
              top: "40%",
              transform: "scale(0.40)",
            },
            "&.casual": {
              top: "55%",
              transform: "scale(0.40)",
            },
            "&.evening": {
              top: "80%",
              transform: "scale(0.40)",
              opacity: 0,
            },
          },
        },
      },
    },

    "&.slide15": {
      ".heading": {
        ".wrapper": {
          "&.element1": {
            opacity: 0,
          },
          "&.element2": {
            opacity: 1,
            bottom: "36%",
          },
        },
      },
      ".animation": {
        ".suggestions": {
          borderRadius: 50,
          background: "#000",
          width: 550,
          height: 580,
          overflow: "hidden",
          "&:before": {
            opacity: 1,
          },

          span: {
            "&.bohemian, &.elegant, &.romantic, &.old, &.coctail, &.smart, &.athletic, &.dinner, &.winter":
              {
                top: "-30%",
              },
            "&.smart, &.athletic, &.dinner, &.winter, &.autumn, &.streetwear, &.edgy, &.casual, &.evening":
              {
                display: "flex",
              },
            "&.autumn": {
              top: "2%",
              transform: "scale(0.40)",
              opacity: 0,
            },
            "&.evening": {
              top: "80%",
              transform: "scale(0.40)",
              opacity: 0,
            },

            "&.streetwear": {
              top: "17%",
              right: "-24%",
              width: 300,
              transform: "scale(0.35)",
              opacity: 0,
            },
            "&.edgy": {
              top: "49%",
              right: "-21%",
              width: 260,
              transform: "scale(0.35)",
              opacity: 0,
            },
            "&.casual": {
              top: "82%",
              right: "-26%",
              width: 300,
              transform: "scale(0.35)",
              opacity: 0,
            },
          },
        },
      },
    },

    "&.slide16": {
      ".heading": {
        ".wrapper": {
          "&.element1": {
            opacity: 0,
          },
          "&.element2": {
            opacity: 0.7,
            bottom: "36%",
            marginLeft: '-20%'
          },
        },
      },
      ".animation": {
        ".suggestions": {
          borderRadius: 50,
          background: "#000",
          width: 550,
          height: 580,
          overflow: "hidden",
          marginRight: '-60%',
          opacity: 0.7,
          "&:before": {
            opacity: 1,
          },

          span: {
            "&.bohemian, &.elegant, &.romantic, &.old, &.coctail, &.smart, &.athletic, &.dinner, &.winter":
              {
                top: "-30%",
              },
            "&.smart, &.athletic, &.dinner, &.winter, &.autumn, &.streetwear, &.edgy, &.casual, &.evening":
              {
                display: "flex",
              },
            "&.autumn, &.evening, &.streetwear, &.edgy, &.casual": {
              opacity: 0,
            },
          },
        },
      },
    },

    "&.slide17": {
      ".heading": {
        ".wrapper": {
          "&.element1": {
            opacity: 0,
          },
          "&.element2": {
            opacity: 0.6,
            bottom: "36%",
            marginLeft: '-30%'
          },
        },
      },
      ".animation": {
        ".suggestions": {
          borderRadius: 50,
          background: "#000",
          width: 550,
          height: 580,
          overflow: "hidden",
          marginRight: '-80%',
          opacity: 0.6,
          "&:before": {
            opacity: 1,
          },

          span: {
            "&.bohemian, &.elegant, &.romantic, &.old, &.coctail, &.smart, &.athletic, &.dinner, &.winter":
              {
                top: "-30%",
              },
            "&.smart, &.athletic, &.dinner, &.winter, &.autumn, &.streetwear, &.edgy, &.casual, &.evening":
              {
                display: "flex",
              },
            "&.autumn, &.evening, &.streetwear, &.edgy, &.casual": {
              opacity: 0,
            },
          },
        },
      },
    },

    "&.slide18": {
      ".final": {
        zIndex: 1,
        opacity: 1,
        backgroundPosition: '-78.8792% 0px',
        backgroundSize: '65%',
      },
      ".heading": {
        ".wrapper": {
          "&.element1": {
            opacity: 0,
          },
          "&.element2": {
            opacity: 0.2,
            bottom: "36%",
            marginLeft: '-50%'
          },
        },
      },
      ".animation": {
        ".suggestions": {
          borderRadius: 50,
          background: "#000",
          width: 550,
          height: 580,
          overflow: "hidden",
          marginRight: '-120%',
          opacity: 0.2,
          "&:before": {
            opacity: 1,
          },

          span: {
            "&.bohemian, &.elegant, &.romantic, &.old, &.coctail, &.smart, &.athletic, &.dinner, &.winter":
              {
                top: "-30%",
              },
            "&.smart, &.athletic, &.dinner, &.winter, &.autumn, &.streetwear, &.edgy, &.casual, &.evening":
              {
                display: "flex",
              },
            "&.autumn, &.evening, &.streetwear, &.edgy, &.casual": {
              opacity: 0,
            },
          },
        },
      },
    },
    "&.slide19": {
      ".final": {
        zIndex: 1,
        opacity: 1,
        backgroundPosition: '-78.8792% 0px',
        backgroundSize: '85%',
      },
      ".heading": {
        ".wrapper": {
          "&.element1": {
            opacity: 0,
          },
          "&.element2": {
            opacity: 0.1,
            bottom: "36%",
            marginLeft: '-60%'
          },
        },
      },
      ".animation": {
        ".suggestions": {
          borderRadius: 50,
          background: "#000",
          width: 550,
          height: 580,
          overflow: "hidden",
          marginRight: '-130%',
          opacity: 0.1,
          "&:before": {
            opacity: 1,
          },

          span: {
            "&.bohemian, &.elegant, &.romantic, &.old, &.coctail, &.smart, &.athletic, &.dinner, &.winter":
              {
                top: "-30%",
              },
            "&.smart, &.athletic, &.dinner, &.winter, &.autumn, &.streetwear, &.edgy, &.casual, &.evening":
              {
                display: "flex",
              },
            "&.autumn, &.evening, &.streetwear, &.edgy, &.casual": {
              opacity: 0,
            },
          },
        },
      },
    },
    "&.slide20": {
      ".final": {
        zIndex: 1,
        opacity: 1,
        backgroundPosition: '-98.8792% 0px',
        backgroundSize: '98%',
      },
      ".heading": {
        ".wrapper": {
          "&.element1": {
            opacity: 0,
          },
          "&.element2": {
            opacity: 0,
            bottom: "36%",
            marginLeft: '-80%'
          },
        },
      },
      ".animation": {
        ".suggestions": {
          borderRadius: 50,
          background: "#000",
          width: 550,
          height: 580,
          overflow: "hidden",
          marginRight: '-150%',
          opacity: 0,
          "&:before": {
            opacity: 1,
          },

          span: {
            "&.bohemian, &.elegant, &.romantic, &.old, &.coctail, &.smart, &.athletic, &.dinner, &.winter":
              {
                top: "-30%",
              },
            "&.smart, &.athletic, &.dinner, &.winter, &.autumn, &.streetwear, &.edgy, &.casual, &.evening":
              {
                display: "flex",
              },
            "&.autumn, &.evening, &.streetwear, &.edgy, &.casual": {
              opacity: 0,
            },
          },
        },
      },
    },
    [desktop]: {
      gap: 80,
      ".final, .heading, .animation": {
        transform: 'scale(0.8)'
      },
    },
    [laptop]: {
      padding: 20,
      gap: 30,
      ".final, .heading, .animation": {
        transform: 'scale(0.55)'
      },
      ".heading": {
        maxWidth: 'auto',
        transform: 'scale(0.45)',
        width: '50%',
      }
    },
    [tablet]: {
      flexDirection: 'column-reverse',
      ".final, .heading, .animation": {
        transform: 'scale(0.50)',
        width: '100%',
      },
      ".final": {
        transform: 'scale(0.70)',
        position: 'absolute',
        top: 0,
        bottom: 0,
        height: '100%',
        margin: 'auto',
        left: 0,
        right: 0,
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'nowrap',
        alignContent: 'center',
        justifyContent: 'center',
        alignItems: 'center',
      },
      ".heading, .animation": {
        height: '50%'
      }
    },
    [mobile]: {
      ".heading, .animation": {
        transform: 'scale(0.40)',
      },
      ".final": {
        transform: 'scale(0.60)'
      },
    },
  }),
};

export default Suggestions;
